import React from 'react';
import PropTypes from 'prop-types';
import store from '../../store';
import { game_path } from 'routes';

const GameResult = ({ game, t_controls }) => {
  const date = new Date(game.started_at);
  const user = store.getState().current_user;
  const locale = user.locale;
  const handleClick = (e) => {
    if (window.Turbolinks) {
      e.preventDefault();
      window.location.href = `${game_path(game.id, { locale: locale })}`;
    }
  };

  return (
    <article className="game-result">
      <a href={`${game_path(game.id, { locale: locale })}`}
        data-turbolinks="false"
        onClick={handleClick}
      >
        <div className="game-result-main">
          <div className="game-result-team game-result-team-first">
            <figure className="game-result-team-figure game-result-team-figure-big">
              <img src={game.home_team_logo} alt={game.home_team_name} />
            </figure>
            <div className="game-result-team-name">{game.home_team_name}</div>
            <div className="game-result-team-country"></div>
          </div>
          <div className="game-result-middle">
            <div className="game-result-score-wrap">
              <div className="game-result-score game-result-team-win">
                {game.home_goals}
                {game.home_goals > game.away_goals && <span className="game-result-team-label game-result-team-label-top">Win</span>}
              </div>
              <div className="game-result-score-divider">
                <svg x="0px" y="0px" width="7px" height="21px" viewBox="0 0 7 21">
                  <g>
                    <circle cx="3.5" cy="3.5" r="3"/>
                    <circle cx="3.5" cy="17.5" r="3"/>
                  </g>
                </svg>
              </div>
              <div className="game-result-score game-result-team-win">
                {game.away_goals}
                {game.away_goals > game.home_goals && <span className="game-result-team-label game-result-team-label-top">Win</span>}
              </div>
            </div>
            <div className="game-results-status">{game.home ? t_controls.home : t_controls.away}</div>
          </div>
          <div className="game-result-team game-result-team-second">
            <figure className="game-result-team-figure game-result-team-figure-big">
              <img src={game.away_team_logo} alt={game.away_team_name} />
            </figure>
            <div className="game-result-team-name">{game.away_team_name}</div>
            <div className="game-result-team-country"></div>
          </div>
        </div>
        <div className="game-result-footer">
          <ul className="game-result-details">
            <li>{game.arena}</li>
            <li>
              <time>{date.toLocaleDateString("en-US", {month: "short", day: "2-digit", year: "numeric"})}</time>
            </li>
          </ul>
        </div>
      </a>
    </article>
  );
};

GameResult.propTypes = {
  game: PropTypes.shape({
    id: PropTypes.number.isRequired,
    home_team_name: PropTypes.string.isRequired,
    home_team_logo: PropTypes.string.isRequired,
    away_team_name: PropTypes.string.isRequired,
    away_team_logo: PropTypes.string.isRequired,
    home_goals: PropTypes.number.isRequired,
    away_goals: PropTypes.number.isRequired,
    arena: PropTypes.string.isRequired,
    started_at: PropTypes.string.isRequired,
  }).isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default GameResult;